import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ breakpoints }: Theme) => ({
  root: {
    zIndex: 0,
    '& main': {
      paddingTop: 0,
    },
  },
  qa: {
    [breakpoints.down(1024)]: {
      margin: '0 auto',
    },
  },
}));
